import scss from './tooltipMarkup.module.scss';

const createTooltipMarkup = ({ tooltipModel }) => {
  if (!tooltipModel) {
    return '';
  }

  const dataPoints = tooltipModel.dataPoints;
  const title = tooltipModel.title[0];
  const r1DataIndex = dataPoints.findIndex(({ dataset }) => dataset.label === 'R1');
  const r2DataIndex = dataPoints.length - r1DataIndex - 1;

  const calculations = [
    {
      label: 'R1',
      value: dataPoints[r1DataIndex].raw === null ? '-/-' : `${dataPoints[r1DataIndex].raw}%`,
      color: 'var(--resonance-blue)',
    },
    {
      label: 'R2',
      value: dataPoints[r2DataIndex].raw === null ? '-/-' : `${dataPoints[r2DataIndex].raw}%`,
      color: 'var(--resonance-green)',
    },
  ];

  return `
    <div class='${scss.outerBox}'>
      <div class='${scss.title}'>
       ${title}
      </div>
      <div class='${scss.infoBlock}'>
        ${calculations.map(createRecord).join('\n')}
      </div>
    </div>
  `;
};

export default createTooltipMarkup;

const createRecord = ({ label, value, color }) => {
  return `
    <div class='${scss.record}'>
     ${color ? `<div class="${scss.marker}" style="background-color: ${color}"></div>` : ''}
      <span class='${scss.label}'>${label}:</span>
      <span class='${scss.value}'>${value}</span>
    </div>
  `;
};
